export const carouselsApi = {
  highlighted: 'productEndpoint/getHighlights',
  suggested: 'productEndpoint/getSuggests',
};
